import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface HuntingFeesFiltersState {
  titleSearch: string;
  categoryId: number | null;
  showSoftDeleted: boolean;
  showSoftDeletedCategories: boolean;
}

const initialState: HuntingFeesFiltersState = {
  titleSearch: '',
  categoryId: null,
  showSoftDeleted: false,
  showSoftDeletedCategories: false,
};

const huntingFeesFiltersSlice = createSlice({
  name: 'huntingFeesFilters',
  initialState,
  reducers: {
    setTitleSearch(state, action: PayloadAction<string>) {
      state.titleSearch = action.payload;
    },
    setCategoryId(state, action: PayloadAction<number | null>) {
      state.categoryId = action.payload;
    },
    setShowSoftDeleted(state, action: PayloadAction<boolean>) {
      state.showSoftDeleted = action.payload;
    },
    setShowSoftDeletedCategories(state, action: PayloadAction<boolean>) {
      state.showSoftDeletedCategories = action.payload;
    },
    resetFilters(state) {
      state.titleSearch = initialState.titleSearch;
      state.categoryId = initialState.categoryId;
      state.showSoftDeleted = initialState.showSoftDeleted;
    },
  },
});

export const { setTitleSearch, setCategoryId, setShowSoftDeleted, setShowSoftDeletedCategories, resetFilters } =
  huntingFeesFiltersSlice.actions;

export const areFiltersAppliedSelector = (state: { huntingFeesFilters: HuntingFeesFiltersState }) => {
  const { titleSearch, categoryId, showSoftDeleted } = state.huntingFeesFilters;
  return !!titleSearch || categoryId !== null || showSoftDeleted;
};

export const activeFiltersCountSelector = (state: { huntingFeesFilters: HuntingFeesFiltersState }) => {
  const { titleSearch, categoryId, showSoftDeleted } = state.huntingFeesFilters;
  let count = 0;
  if (titleSearch) count++;
  if (categoryId !== null) count++;
  if (showSoftDeleted) count++;
  return count;
};

export const areCategoryFiltersAppliedSelector = (state: { huntingFeesFilters: HuntingFeesFiltersState }) =>
  state.huntingFeesFilters.showSoftDeletedCategories;

export const activeCategoryFiltersCountSelector = (state: { huntingFeesFilters: HuntingFeesFiltersState }) =>
  state.huntingFeesFilters.showSoftDeletedCategories ? 1 : 0;

export const huntingFeesFiltersActions = huntingFeesFiltersSlice.actions;

export const huntingFeesFilters = huntingFeesFiltersSlice.reducer;
